import React from 'react'
import Legacy from './Legacy'

const OrderApprovalList = (props) => {
  return <Legacy {...props}/>
}

export default OrderApprovalList
